import { ArrowLeftOutlined,SettingOutlined } from "@ant-design/icons";
import { Button,Flex,Grid,Tooltip,Typography } from "../../../../../shared/frontend/ui";
import React from "react";
import { spacing } from "../app/design-system";
import type { LocalizedText } from "../app/i18n/i18n";
import { useI18n } from "../app/i18n/useI18n";

type TemplateEditorHeaderProps = {
  title: React.ReactNode;
  saving?: boolean;
  onBack: () => void;
  onOpenSettings: () => void;
  onSave: () => void;
  extraActions?: React.ReactNode;
  backLabel?: LocalizedText;
  /** Bedienelemente links neben den Kopfaktionen, wenn der Fachbereich den Titel außerhalb zeigt. */
  leading?: React.ReactNode;
  /** Der Kopf liegt innerhalb einer Card und braucht dort keinen eigenen Außenabstand. */
  embedded?: boolean;
  hideBackIcon?: boolean;
  hideBackButton?: boolean;
  hideTitle?: boolean;
  saveText?: LocalizedText;
  showSettings?: boolean;
};

export function TemplateEditorHeader(props: TemplateEditorHeaderProps) {
  const {
    title,
    saving,
    onBack,
    onOpenSettings,
    onSave,
    extraActions,
    backLabel = "Back to settings",
    leading,
    embedded = false,
    hideBackIcon,
    hideBackButton,
    hideTitle,
    saveText = "Save",
    showSettings = true
  } = props;
  const { tr, text } = useI18n();
  const screens = Grid.useBreakpoint();
  const isMobile = screens.md === false;

  return (
    <Flex
      align={isMobile ? "stretch" : "center"}
      justify="space-between"
      gap={spacing.md}
      vertical={isMobile}
      style={{ marginBottom: embedded ? 0 : spacing.xl }}
    >
      <Flex align="center" gap={spacing.md} style={{ minWidth: 0, flex: "1 1 auto" }}>
        {hideBackButton ? null : (
          <Tooltip title={isMobile ? text(backLabel) : undefined}>
            <Button
              type="text"
              size="small"
              icon={hideBackIcon ? undefined : <ArrowLeftOutlined />}
              aria-label={text(backLabel)}
              onClick={onBack}
              style={{ paddingLeft: 0 }}
            >
              {isMobile ? null : text(backLabel)}
            </Button>
          </Tooltip>
        )}
        {hideTitle ? leading : (
          <Typography.Title level={4} style={{ margin: 0, overflowWrap: "anywhere" }} data-page-heading="primary">
            {title}
          </Typography.Title>
        )}
      </Flex>
      <Flex
        align="center"
        justify="flex-end"
        gap={spacing.sm}
        wrap="wrap"
        style={{ minWidth: 0, width: isMobile ? "100%" : undefined }}
      >
        {showSettings ? (
          <Button icon={<SettingOutlined />} onClick={onOpenSettings}>
            {tr("Settings")}
          </Button>
        ) : null}
        {extraActions}
        <Button type="primary" loading={saving} onClick={onSave}>
          {text(saveText)}
        </Button>
      </Flex>
    </Flex>
  );
}
